import { useRouter } from 'next/router';

export const useCertId = () => {
  const router = useRouter();
  return router.query.certId;
};
